import React from 'react'
import Data from '../db/data.js'
import ProductCard from '../components/ProductCard.js'

const BestSeller = () => {
    
    const data = Data
  return (
    <div className=' mt-3 p-4 flex flex-col items-center'>
        <h1 className='text-center font-semibold  text-4xl'>Best Seller</h1>
        <p className='text-center text-gray-700'>Discover our most popular pieces loved by customers</p>
        <div className='flex flex-wrap justify-center items-center gap-12 w-[80%] mt-6'>
        {data.slice(0, 5).map((card) => ( <ProductCard card={card} key={card.id} />))}
        </div>
    </div>
  )
}

export default BestSeller